import type { LocaleCode } from '@/i18n/locales'
import type { HomePageLocaleContent } from '../types'
import { homePageEn } from './en'
import { homePageEs } from './es'

const contentByLocale: Partial<Record<LocaleCode, HomePageLocaleContent>> = {
  en: homePageEn,
  es: homePageEs,
}

export function getHomePageContent(locale: LocaleCode): HomePageLocaleContent {
  return contentByLocale[locale] ?? homePageEn
}
